import { useNavigate } from 'react-router-dom';
import {
  EllipsisVertical,
  Pencil
  // Trash
} from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';
import { getBadgeVariant } from '@/app/coachActivityTenant/enums';
import { Badge } from '@/components/ui/badge';

// import DeleteCoachDialog from './DeleteCoachDialog';
// import EditCoachDialog from './EditCoachDialog';

const CoachRow = ({ coach }) => {
  //   const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  //   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/coach/${coach.id}`);
  };

  return (
    <>
      <TableRow onClick={handleRowClick} className="cursor-pointer">
        <TableCell className="py-2">
          {coach.user.firstname} {coach.user.lastname}
        </TableCell>
        <TableCell className="py-2">
          {coach.coachActivities.map((activity) => (
            <span key={activity.id} className="block py-1">
              {activity.activity.title}:{' '}
              <Badge
                variant={getBadgeVariant(
                  activity.coachActivityTenants[0].status
                )}
              >
                {activity.coachActivityTenants[0].status}
              </Badge>
            </span>
          ))}
        </TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild onClick={(e) => e.stopPropagation()}>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent onClick={(e) => e.stopPropagation()}>
              <DropdownMenuLabel>{coach.name}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <Pencil />
                Edit Coach
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
      {/* {isEditDialogOpen && (
        <EditCoachDialog coach={coach} setOpen={setIsEditDialogOpen} />
      )}
      {isDeleteDialogOpen && (
        <DeleteCoachDialog coach={coach} setOpen={setIsDeleteDialogOpen} />
      )} */}
    </>
  );
};

export default CoachRow;
